<template>
  <page>
                <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-filter-variant</v-icon>Selection Criteria</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="ePanelHeaderColor">
    <v-card>
      <v-card-text>
        <form>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field v-model="form.acctNoFromDis" :label="labels.acctNoFrom" :error-messages="errors.collect('acctNoFrom')"
                  :data-vv-as="labels.acctNoFrom" data-vv-name="acctNoFrom" append-icon="mdi-magnify" @click:append="getHelpList('acctNoFrom')"
                   readonly v-validate="acctNoValidate('accNoFrom')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field v-model="form.acctNoToDis" :label="labels.acctNoTo" :error-messages="errors.collect('acctNoTo')"
                  :data-vv-as="labels.acctNoTo" data-vv-name="acctNoTo" append-icon="mdi-magnify" @click:append="getHelpList('acctNoTo')"
                  readonly v-validate="acctNoValidate('acctNoTo')">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field v-model="form.acctPerFrom" :label="labels.acctPerFrom" :error-messages="errors.collect('acctPerFrom')"
                  :data-vv-as="labels.acctPerFrom" data-vv-name="acctPerFrom" append-icon="mdi-magnify" @click:append="getHelpList('acctPerFrom')"
                  readonly v-validate="acctPeriodValidate('acctPerFrom')">
                </v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field v-model="form.acctPerTo" :label="labels.acctPerTo" :error-messages="errors.collect('acctPerTo')"
                  :data-vv-as="labels.acctPerTo" data-vv-name="acctPerTo" append-icon="mdi-magnify" @click:append="getHelpList('acctPerTo')"
                  readonly v-validate="acctPeriodValidate('acctPerTo')">
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </form>
      </v-card-text>
    </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 lg12>
                <v-checkbox color="primary" :label="labels.rptParam" v-model="form.rptParam"></v-checkbox>
              </v-flex>
              <v-flex xs12 lg6>
                <!-- <v-btn class="mr-2" color="info" :loading="submitting" @click.prevent="doSchedule">
                  <v-icon left dark>mdi-clock</v-icon>
                  {{labels.schedule}}
                </v-btn> -->
                <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                  <v-icon left dark>mdi-file-export</v-icon>
                  {{labels.export}}
                </v-btn>
                 <v-btn-toggle dense mandatory v-model="form.format">
                  <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                    <span>{{format.label}}</span>
                    <v-icon :color="format.color">{{format.icon}}</v-icon>
                  </v-btn>
                 </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
    <v-dialog v-model="showGlAcctNoHelpList" width="1280px"  >
      <gl-acct-no-help-list2 objData= 'screen_2' @close="showGlAcctNoHelpList = false" @assign-gl-acct-info="doAssign($event)"></gl-acct-no-help-list2>
    </v-dialog>

    <v-dialog v-model="showAcctPeriodHelpList" width="1280px"  >
      <acct-period-help-list2 @close="showAcctPeriodHelpList = false" @assign-acct-period-info="doAssign($event)"></acct-period-help-list2>
    </v-dialog>

    <v-dialog v-model="scheduleJobModal" width="1000px"   persistent>
      <ScheduleJob @close="scheduleJobModal = false" :jobName="jobName" :jobDesc="jobDesc"></ScheduleJob>
    </v-dialog>

  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import ScheduleJob from '@/components/core/common/dialog/ScheduleJob'
import GlAcctNoHelpList2 from '@/components/core/common/dialog/GlAcctNoHelpList2'
import AcctPeriodHelpList2 from '@/components/core/common/dialog/AcctPeriodHelpList2'

export default {
  data() {
    return {
      labels: {
        acctNoFrom: 'GL Account No. From*',
        acctNoTo: 'GL Account No. To*',
        acctPerFrom: 'Accounting Period From*',
        acctPerTo: 'Accounting Period To*',
        format: 'Export Format',
        export: 'Export to',
        schedule: 'Schedule',
        rptParam: 'Print Runtime Parameters'
      },
      form: {
        acctNoFrom: '',
        acctNoTo: '',
        acctPerFrom: '',
        acctPerTo: '',
        format: 'PDF',
        acctNoFromDis: '',
        acctNoToDis: '',
        rptParam: true
      },
      menu: {},
      supportedFormat: [],
      submitting: false,
      mode: '',
      showGlAcctNoHelpList: false,
      showAcctPeriodHelpList: false,
      scheduleJobModal: false,
      jobName: 'qrtzGLStat',
      jobDesc: 'GL Stat',
      panel: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.glStat
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      switch (fieldName) {
        case 'acctNoFrom':
        case 'acctNoTo':
          this.showGlAcctNoHelpList = true
          break
        case 'acctPerFrom':
        case 'acctPerTo':
          this.showAcctPeriodHelpList = true
          break
      }
    },
    doAssign(data) {
      switch (this.mode) {
        case 'acctNoFrom':
          this.form.acctNoFrom = data.glacctNo
          let fromDesc = data.description.length > 30 ? data.description.substring(0, 30) : data.description
          this.form.acctNoFromDis = data.branch + ' - ' + data.glacctNo + ' - ' + data.fund + ' - ' + data.acctNoSfx + ' - ' + fromDesc
          break
        case 'acctNoTo':
          this.form.acctNoTo = data.glacctNo
          let toDesc = data.description.length > 30 ? data.description.substring(0, 30) : data.description
          this.form.acctNoToDis = data.branch + ' - ' + data.glacctNo + ' - ' + data.fund + ' - ' + data.acctNoSfx + ' - ' + toDesc
          break
        case 'acctPerFrom':
          this.form.acctPerFrom = data.acctPerMth + '/' + data.acctPerYr
          break
        case 'acctPerTo':
          this.form.acctPerTo = data.acctPerMth + '/' + data.acctPerYr
          break
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportGlStat
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doSchedule() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.scheduleJobModal = true
        }
      })
    },
    acctNoValidate(fieldName) {
      if (fieldName === 'acctNoFrom') {
        return 'required|acctNoRangeFrom:' + this.form.acctNoTo
      } else {
        return 'required|acctNoRangeTo:' + this.form.acctNoFrom
      }
    },
    acctPeriodValidate(fieldName) {
      if (fieldName === 'acctPerFrom') {
        return 'required|acctPerRangeFrom:' + this.form.acctPerTo
      } else {
        return 'required|acctPerRangeTo:' + this.form.acctPerFrom
      }
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('acctNoRangeFrom', {
      getMessage(field, args) {
        return field + ' must less than or equal To Account No.'
      },
      validate(value, args) {
        if (value < args) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('acctNoRangeTo', {
      getMessage(field, args) {
        return field + ' must greater than or equal From Account No.'
      },
      validate(value, args) {
        if (value < args) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('acctPerRangeFrom', {
      getMessage(field, args) {
        return field + ' must less than or equal To Accouting Period'
      },
      validate(value, args) {
        let tAcctPerFrom = value.split('/')
        let acctPerFrom = ''
        if (tAcctPerFrom[0].length === 1) {
          acctPerFrom = tAcctPerFrom[1] + '0' + tAcctPerFrom[0]
        } else {
          acctPerFrom = tAcctPerFrom[1] + tAcctPerFrom[0]
        }
        let tAcctPerTo = args[0].split('/')
        let acctPerTo = ''
        if (tAcctPerTo[0].length === 1) {
          acctPerTo = tAcctPerTo[1] + '0' + tAcctPerTo[0]
        } else {
          acctPerTo = tAcctPerTo[1] + tAcctPerTo[0]
        }
        if (parseInt(acctPerFrom) > parseInt(acctPerTo)) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('acctPerRangeTo', {
      getMessage(field, args) {
        return field + ' must greater than or equal From Accouting Period'
      },
      validate(value, args) {
        let tAcctPerFrom = args[0].split('/')
        let acctPerFrom = ''
        if (tAcctPerFrom[0].length === 1) {
          acctPerFrom = tAcctPerFrom[1] + '0' + tAcctPerFrom[0]
        } else {
          acctPerFrom = tAcctPerFrom[1] + tAcctPerFrom[0]
        }
        let tAcctPerTo = value.split('/')
        let acctPerTo = ''
        if (tAcctPerTo[0].length === 1) {
          acctPerTo = tAcctPerTo[1] + '0' + tAcctPerTo[0]
        } else {
          acctPerTo = tAcctPerTo[1] + tAcctPerTo[0]
        }
        if (parseInt(acctPerTo) < parseInt(acctPerFrom)) {
          return false
        } else {
          return true
        }
      }
    })
  },
  mixins: [
    MessageMixin
  ],
  components: {
    GlAcctNoHelpList2,
    AcctPeriodHelpList2,
    ScheduleJob
  }
}
</script>
